import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const axiosPublic = axios.create({
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
    },
});